import React, {Component} from 'react';
import passed from '../../../../assets/img/performances/PASSED_GREEN@2x.png';
import {Col, Row} from 'react-bootstrap'
import { camelCase } from 'lodash';

class PerformanceBarPrize extends Component {
  hasReachedTarget() {
    const { incentive } = this.props;
    return incentive.packs_sold >= incentive.target
  }

  hasReachedBaseTarget() {
    const { incentive } = this.props;
    return incentive.packs_sold >= incentive.base_target
  }

  performanceBarBGColor() {
    if (this.hasReachedTarget()) {
      return '#70bd4d';
    }
    return '#ffc734';
  }

  performanceBaseTargetBarBGColor() {
    if (this.hasReachedBaseTarget()) {
      return '#70bd4d';
    }
    return '#ffc734';
  }

  incentiveIsPacksSold = () => {
      const { incentive } = this.props;
      return incentive.kind === 'packs_sold';
  }

  incentiveIsFixedTarget = () => {
      const { incentive } = this.props;
      return incentive.kind === 'fixed_target';
  }

  incentiveIsBaseTarget = () => {
    const { incentive } = this.props;
    return incentive.kind === 'base_target';
  }


  render() {
    const { incentive } = this.props;
    const progress = Math.min(Math.floor((incentive.packs_sold / incentive.target) * 100), 100);
    const baseTargetProgress = this.incentiveIsBaseTarget() ? Math.min(Math.floor((incentive.base_target / incentive.target) * 100), 100) : 0;
    let target1, target2;

    if (this.incentiveIsBaseTarget()){
        target1 = incentive.base_target;
        target2 = incentive.target;
    } else if (this.incentiveIsFixedTarget()){
        target1 = incentive.target_1;
        target2 = incentive.target_2;
    } else if (this.incentiveIsPacksSold()) {
        target2 = incentive.target;
    }
    return (
      <div className="performance-bar-wrapper performance-prize-wrapper">
        <div>
          {!this.hasReachedTarget() && (
            <div className="sold-indicator" style={ { left: `calc(${progress}% - 15px)` } }>
              <strong>{incentive.packs_sold}</strong>
              <span className="glyphicon glyphicon-triangle-bottom" aria-hidden="true"></span>
            </div>
          )}
          <div className="performance-bar-back prize-wrapper"></div>
          <div className="performance-bar prize-wrapper" style={ { backgroundColor: this.performanceBarBGColor(), width: `calc(100% - 48px)` } }></div>
          {this.incentiveIsBaseTarget() && (
            <div className="performance-bar" style={ { left: 0, width: `${baseTargetProgress}%`, zIndex: 10, backgroundColor: this.performanceBaseTargetBarBGColor() } }></div>
          )}
          <div className="performance-bar-overlay prize-wrapper" style={ { width: `${100 - progress}%` } }></div>
        </div>
        <div className='prize-container'>
            <div className='prize'>
              <img className={`prize-image ${this.hasReachedTarget() ? 'won' : ''}`} src={incentive.prize_image}/>
            </div>
          {this.hasReachedTarget() && (
            <div className="prize-won">
              <div className="prize-won-image-container">
                <img src={passed} />
              </div>
            </div>
          )}
          <div>
            <div  className={`target-label-container ${this.hasReachedTarget() ? 'won' : ''}`}>
              <div className="target-label">Target</div>
              <div className="target-value"><strong>{target2}</strong></div>
            </div>
            {(this.incentiveIsBaseTarget() || this.incentiveIsFixedTarget()) && (
              <div  className={`target-label-container ${this.hasReachedTarget() ? 'won' : ''}`}>
                <div className="target-label">Target</div>
                <div className="target-value"><strong style={{ color: this.performanceBaseTargetBarBGColor() }}>{target1}</strong></div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default PerformanceBarPrize;



// WEBPACK FOOTER //
// ./src/components/common/store-performances/performance-bar/performance-bar-prize.jsx